<template>
   <div class="card mb-3">
    <div class="card-body">
      <small class="text-muted" data-toggle="tooltip" :title="sug_created_format">Suggestion #{{suggestion.sug_id}}
        (<i><timeago :datetime="sug_created_date" :auto-update="60"></timeago></i>)
      </small>
      <nl2br tag="p" :text="suggestion_text" />
      <div v-show="response_text || editing">
        <hr>
        <small class="text-muted" data-toggle="tooltip" :title="resp_updated_format">
          Manager Response <span v-show="!editing">(<i><timeago :datetime="resp_updated_date" :auto-update="60"></timeago></i>)</span>
        </small>
        <div>
          <div class="form-group">
            <b-form-textarea ref="response" :key="suggestion.sug_id" v-model="suggestion.response" :plaintext="!editing" rows="1" max-rows="100" @keydown="handleCmdEnter($event)"></b-form-textarea>
          </div>
          <div class="form-group" v-show="editing">
            <b-button size="sm" variant="outline-success" @click="saveResponse($event)"><i class="fa fa-save"></i> Save response</b-button>&nbsp;
            <b-button size="sm" variant="outline-danger" @click="cancelEdit"><i class="fa fa-ban"></i> Cancel</b-button>
          </div>
        </div>
      </div>
      <b-button v-show="!editing && responding" size="sm" :variant="response_text ? 'outline-secondary' : 'outline-primary'" @click="edit"><i class="fa fa-edit"></i> {{edit_button_text}}</b-button>&nbsp;
      <b-button v-show="responding" size="sm" variant="outline-info" @click="archiveSuggestion($event)"><i class="fa fa-archive"></i> Archive Suggestion</b-button>&nbsp;
      <votes :suggestion="suggestion" v-if="response_original" v-show="!editing"></votes>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Votes from '@/components/Votes'

export default {
  name: 'SuggestionItem',

  components: {
    'Votes': Votes
  },

  data () {
    return {
      editing: false,
      response_original: this.suggestion.response
    }
  },

  props: ['suggestion', 'responding'],

  methods: {
    edit () {
      this.editing = true
      this.$refs.response.$el.focus()
      this.$refs.response.$el.setSelectionRange(this.suggestion.response.length, this.suggestion.response.length)
    },

    archiveSuggestion() {
      var r = confirm("Are you sure you want to archive this suggestion?")
      if (r) {
        this.$http
          .patch(process.env.VUE_APP_URL + '/suggestions/' + this.suggestion.sug_id + '/archive')
          .then(response =>{
            if (response) {
              this.$router.go()
            }
          })
      }

    },

    saveResponse (e) {
      e.target.blur()
      this.editing = false
      if (this.suggestion.response != this.response_original) {
        this.$http
          .patch(process.env.VUE_APP_URL + '/suggestions/' + this.suggestion.sug_id, {
            response: this.suggestion.response
          })
          .then(response => {
            this.suggestion = response.data
            this.response_original = this.suggestion.response
          })
      }
    },
    cancelEdit () {
      this.editing = false
      this.suggestion.response = this.response_original
    },
    handleCmdEnter: function (e) {
      if ((e.metaKey || e.ctrlKey) && e.keyCode == 13) {
        this.saveResponse(e)
      }
    }
  },

  computed: {
    edit_button_text: function () {
      return this.response_text ? 'Edit Response' : 'Write Response'
    },
    suggestion_text: function () {
      if (this.suggestion.suggestion === null) {
        return ''
      } else {
        return this.suggestion.suggestion
      }
    },
    response_text: function () {
      if (this.suggestion.response === null) {
        return ''
      } else {
        return this.suggestion.response
      }
    },
    sug_created_date: function () {
      return moment(this.suggestion.sug_created)
    },
    sug_created_format: function () {
      return moment(String(this.suggestion.sug_created)).format('DD/MM/YYYY hh:mm')
    },
    resp_updated_format: function () {
      return moment(String(this.suggestion.resp_updated)).format('DD/MM/YYYY hh:mm')
    },
    resp_updated_date: function () {
      return moment(this.suggestion.resp_updated)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
